import React, {PropsWithChildren} from "react"
import {IntlProvider} from "react-intl"
import {theme} from 'antd'
import {pick} from "lodash-es"
// import {useStore} from "@ui/stores"
import {observer} from "mobx-react-lite"
import {ConfigProvider} from "antd"
// import en from "antd/es/locale/en_US"
import ru from "antd/es/locale/ru_RU"
import uiRu from "@ui/i18n/ru.json"
// import uiEn from "@ui/i18n/en.json"

const locales = [
  "ru",
  // "en"
] as const

type LangMessages = {
  [k: string]: Record<string, string> | undefined
}

const allMessages = pick({
  ru: uiRu,
  // en: uiEn
}, locales) as LangMessages

const getAntdLocale = (locale: typeof locales[number]) => {
  // switch (locale) {
  //   case "en":
  //     return en
  // }
  return ru
}

const LocaleProvider = ({children}: PropsWithChildren<{}>): React.ReactElement => {
  // const {user} = useStore()
  const locale = "ru" // user.settings.locale as typeof locales[number]

  return (
    <IntlProvider key={locale} locale={locale} defaultLocale="ru" messages={allMessages[locale]}>
      <ConfigProvider locale={getAntdLocale(locale)} theme={theme.defaultConfig}>
        {children}
      </ConfigProvider>
    </IntlProvider>
  )
}

export default observer(LocaleProvider)
